import {LOGIN_SUCCESS, LOGIN_FAIL, LOGOUT} from '../constants/auth';
import {GAME_URL} from '../constants';
import axios from "axios";


export const postLogin = ({username, password}) => {
    const url = `${GAME_URL}/Auth/login`;
    const params = new URLSearchParams();
    params.append('username', username);
    params.append('password', password);
    let config = {
        method:'POST',
        url,
        params,
        headers: {
            "Content-Type": "application/x-www-form-urlencoded"
        }
    }
   return  async(dispatch) => {
       try {
        var res = await axios(config);
        if(res.data && res.data?.type === 'Student'){
        console.log('login Succes Res', res.data);
        dispatch({
            type: LOGIN_SUCCESS,
            payload: res.data
        });
        }
        else {
            dispatch({
                type: LOGIN_FAIL,
                payload: "Please log in at Platform.ObjectiveEd.com"
            })
        }
       } catch(err) {
           console.log('inside catch', err);
           dispatch({
               type: LOGIN_FAIL,
               payload: "Incorrect Username/Password"
           })
       }
    
    
} 
};

export const logout = () => {
    return {
        type: LOGOUT
    }
}